import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import PublicLayout from "@/components/PublicLayout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Tornei from "@/pages/Tornei";
import Clan from "@/pages/Clan";
import Campionati from "@/pages/Campionati";
import Squadre from "@/pages/Squadre";
import Giocatori from "@/pages/Giocatori";
import VerificheKD from "@/pages/VerificheKD";
import Lobby from "@/pages/Lobby";
import Risultati from "@/pages/Risultati";
import Classifiche from "@/pages/Classifiche";
import Impostazioni from "@/pages/Impostazioni";
import LogAttivita from "@/pages/LogAttivita";
import Utenti from "@/pages/Utenti";
// Public site
import SealsOfWarzone from "@/pages/public/SealsOfWarzone";
import SealsAlliesForce from "@/pages/public/SealsAlliesForce";
import PubTornei from "@/pages/public/PubTornei";
import TorneoDetail from "@/pages/public/TorneoDetail";
import PubCampionati from "@/pages/public/PubCampionati";
import CampionatoDetail from "@/pages/public/CampionatoDetail";
import StoricoPlayer from "@/pages/public/StoricoPlayer";
import Contatti from "@/pages/public/Contatti";
import PrivacyPolicy from "@/pages/public/PrivacyPolicy";
import CookiePolicy from "@/pages/public/CookiePolicy";
import Termini from "@/pages/public/Termini";
import NotFound from "@/pages/public/NotFound";

const VIEWER_DASH_PATHS = new Set([
  "/clan",
  "/squadre",
  "/giocatori",
  "/lobby",
  "/classifiche",
]);

function Protected({ children, adminOnly = false, path = "" }) {
  const { user } = useAuth();
  if (user === null) return <div className="relative z-10 min-h-screen flex items-center justify-center heading text-3xl gold-text">Caricamento sistema...</div>;
  if (!user) return <Navigate to="/dashboard/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  if (user.role === "viewer" && !VIEWER_DASH_PATHS.has(path)) {
    return <Navigate to="/dashboard/clan" replace />;
  }
  return <Layout>{children}</Layout>;
}

const ADMIN_DASH_PATHS = new Set([
  "/utenti",
  "/log",
]);

const dashRoutes = [
  ["", Dashboard], ["/tornei", Tornei], ["/campionati", Campionati], ["/clan", Clan], ["/squadre", Squadre], ["/giocatori", Giocatori],
  ["/verifiche-kd", VerificheKD],
  ["/lobby", Lobby], ["/risultati", Risultati], ["/classifiche", Classifiche],
  ["/impostazioni", Impostazioni], ["/log", LogAttivita],
  ["/utenti", Utenti],
];

const publicRoutes = [
  ["/seals-of-warzone", SealsOfWarzone], ["/seals-allies-force", SealsAlliesForce],
  ["/tornei", PubTornei], ["/tornei/:id", TorneoDetail], ["/campionati", PubCampionati], ["/campionati/:id", CampionatoDetail], ["/storico-player", StoricoPlayer], ["/contatti", Contatti],
  ["/privacy-policy", PrivacyPolicy], ["/cookie-policy", CookiePolicy], ["/termini", Termini],
];

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" theme="dark" toastOptions={{ style: { background: "#141414", border: "1px solid #C9A227", color: "#fff", fontFamily: "Rajdhani" } }} />
        <Routes>
          <Route path="/" element={<Navigate to="/seals-of-warzone" replace />} />
          {publicRoutes.map(([path, C]) => (
            <Route key={path} path={path} element={<PublicLayout><C /></PublicLayout>} />
          ))}

          <Route path="/dashboard/login" element={<Login />} />
          {dashRoutes.map(([path, C]) => (
            <Route
              key={path}
              path={`/dashboard${path}`}
              element={
                <Protected adminOnly={ADMIN_DASH_PATHS.has(path)} path={path}>
                  <C />
                </Protected>
              }
            />
          ))}

          <Route path="*" element={<PublicLayout><NotFound /></PublicLayout>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
